import castArray from "lodash/fp/castArray";
import flatMap from "lodash/fp/flatMap";
import flow from "lodash/fp/flow";

const getRequiredFields = (userChoices) =>
  flow(
    flatMap(castArray),
    flatMap(
      ({ name, options = [], isRequired = false, isDisabled, validation }) => {
        const selectedOption = options.find(
          ({ value }) => value === userChoices[name]
        );
        return [
          { name, isRequired, isDisabled, validation },
          ...getRequiredFields(userChoices)(selectedOption?.fields || []),
        ];
      }
    )
  );

export default getRequiredFields;
